// pinned: the top bar is fixed to the top of the screen, where sites pin their own headers too. While it
// shows, the site's fixed or sticky header moves down by its height, and the page's scroll padding grows
// by it too, so a jump to an anchor or to a focused field never lands under the bar. Only that header's
// `top` and the page's `scroll-padding-top` are touched, and both are put back when our bar goes away.

/** What we moved: the element, its own inline `top`, and where it naturally sat (px). @type {[HTMLElement, string, number][]} */
let moved = [];
/** The page's own inline scroll-padding-top while ours is added; null when nothing is added. @type {string | null} */
let padded = null;

/** @param {Element} e */
const ours = e => !!e.closest('sl-slot, sl-row');

/**
 * Make room for our top bar. Undoes the last call first, so it is safe to call after every render.
 * @param {HTMLElement | null} top  our top bar, if one shows
 */
export function makeRoom(top) {
    const before = moved, page = document.documentElement.style;
    for (const [e, was] of before) e.style.top = was;
    moved = [];
    if (padded !== null) page.scrollPaddingTop = padded;
    padded = null;
    if (!top) return;
    padded = page.scrollPaddingTop;
    page.scrollPaddingTop = (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0) + top.offsetHeight + 'px';
    // Where a moved header naturally sits comes from the last call, not from measuring it again: a
    // site's CSS transition on top (Tailwind's transition-all) still reports the moved value.
    /** @param {Element} e */
    const natural = e => before.find(m => m[0] === e)?.[2];
    const heads = new Set([...document.body.children, ...document.querySelectorAll('header, nav, [class*=header], [class*=navbar], [class*=topbar]')]);
    for (const e of heads) {
        const cs = getComputedStyle(e);
        if (ours(e) || !/fixed|sticky/.test(cs.position) || (natural(e) ?? parseFloat(cs.top)) !== 0) continue;
        const h = /** @type {HTMLElement} */ (e);
        moved.push([h, h.style.top, 0]);
        h.style.top = top.offsetHeight + 'px';
    }
}
